import {margin as m} from 'polished'

export const margin = props => {
  let style = ''
  if (props.margin) {
    style = m(...props.margin)
  }
  if (props.marginTop) {
    style += `margin-top: ${props.marginTop};`
  }
  if (props.marginRight) {
    style += `margin-right: ${props.marginRight};`
  }
  if (props.marginBottom) {
    style += `margin-bottom: ${props.marginBottom};`
  }
  if (props.marginLeft) {
    style += `margin-left: ${props.marginLeft};`
  }
  return style
}

export const responsive = (field, desktop, mobile) => (`
  ${field}: ${desktop};
  
  @media(max-width: 640px) {
    ${field}: ${mobile};
  }
`)


// WEBPACK FOOTER //
// ./assets/common/styledHelpers.js